import type { ModerationSeverity } from '../../../OracleCommons/moderationUtils'
import type { PostHogContextRef } from '../context'
import { buildInChatContextProperties } from '../context'

/**
 * AI moderation / safety events. Fire from AI chat moderation guardrails.
 */
export type ModerationEvents = {
  ai_moderation_violation: (severity: ModerationSeverity, categories: string[]) => void
}

export function createModerationEventCallbacks (
  contextRef: PostHogContextRef,
): ModerationEvents {
  return {
    ai_moderation_violation: (severity: ModerationSeverity, categories: string[]) => {
      const ctx = contextRef.current
      if (!ctx.posthogClient) return
      ctx.posthogClient.capture('ai_moderation_violation', {
        ...buildInChatContextProperties(ctx),
        severity,
        categories,
      })
    },
  }
}
